module.exports = __webpack_public_path__ + "static/17-220aaa75259f75ad132edd68f23dfa81.jpg";